/**
 * @generated SignedSource<<25e0473d4d4c59a69c3eaa2afaa407ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type AssignmentState = "COMPLETE" | "IN_PROGRESS" | "%future added value";
export type AssignmentsFilterInput = {
  assignmentState?: AssignmentState | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  dueOnFrom?: any | null | undefined;
  dueOnTo?: any | null | undefined;
  isActive: ActiveRecords;
  nameContains?: string | null | undefined;
  skillIds?: ReadonlyArray<string> | null | undefined;
  startedOnFrom?: any | null | undefined;
  startedOnTo?: any | null | undefined;
};
export type AssignmentStatusCountsQuery$variables = {
  activeFilter: AssignmentsFilterInput;
  allFilter: AssignmentsFilterInput;
};
export type AssignmentStatusCountsQuery$data = {
  readonly activeAssignments: {
    readonly totalCount: number;
  } | null | undefined;
  readonly allAssignments: {
    readonly totalCount: number;
  } | null | undefined;
};
export type AssignmentStatusCountsQuery = {
  response: AssignmentStatusCountsQuery$data;
  variables: AssignmentStatusCountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activeFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allFilter"
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": "allAssignments",
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "allFilter"
      },
      (v2/*: any*/)
    ],
    "concreteType": "AssignmentNodeConnection",
    "kind": "LinkedField",
    "name": "assignments",
    "plural": false,
    "selections": (v3/*: any*/),
    "storageKey": null
  },
  {
    "alias": "activeAssignments",
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "activeFilter"
      },
      (v2/*: any*/)
    ],
    "concreteType": "AssignmentNodeConnection",
    "kind": "LinkedField",
    "name": "assignments",
    "plural": false,
    "selections": (v3/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentStatusCountsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssignmentStatusCountsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "38794956ee5d3347fb00cc53fe12e33b",
    "id": null,
    "metadata": {},
    "name": "AssignmentStatusCountsQuery",
    "operationKind": "query",
    "text": "query AssignmentStatusCountsQuery(\n  $allFilter: AssignmentsFilterInput!\n  $activeFilter: AssignmentsFilterInput!\n) {\n  allAssignments: assignments(filter: $allFilter, first: 1) {\n    totalCount\n  }\n  activeAssignments: assignments(filter: $activeFilter, first: 1) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "9795fe2d107cb7b1d1908973a39d4428";

export default node;
